var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100%" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(_vm._s(_vm.title)),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("common.close"),
                  expression: "$ct('common.close')",
                },
              ],
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { staticClass: "mr", attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        { staticClass: "content" },
        [
          _vm.ready
            ? _c("app-edit-bank", {
                attrs: { bank: _vm.booking, "show-edit-composition": "" },
                on: {
                  "update:bank": function ($event) {
                    _vm.booking = $event
                  },
                  "bank-saved": function ($event) {
                    return _vm.onBankSave($event)
                  },
                  update: function ($event) {
                    return _vm.updateView()
                  },
                  cancel: function ($event) {
                    return _vm.close()
                  },
                },
              })
            : _c(
                "div",
                { staticClass: "loading" },
                [_c("w-progress-circular")],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }